<div class="modal-header">
	<h4 class="modal-title">{{ 'countrySelectDialog.confirmation.title' | translate }}</h4>
	<button type="button" class="close" aria-label="Close" (click)="decline()">
		<cfe-icon [iconName]="'close'"></cfe-icon>
	</button>
</div>

<div class="modal-body">
	<img class="modal-icon mb-3" src="assets/images/info.png" alt="" />

	<p *ngIf="countSelected > 0">
		{{ 'countrySelectDialog.confirmation.select' | translate: { count: countSelected } }}
	</p>

	<ng-container *ngIf="countDeselected > 0">
		<p>
			{{ 'countrySelectDialog.confirmation.deselect' | translate: { count: countDeselected } }}<br />
			{{ 'countrySelectDialog.confirmation.consequences' | translate }}
		</p>
	</ng-container>

	<p>{{ 'countrySelectDialog.confirmation.question' | translate }}</p>
</div>

<div class="modal-footer">
	<button class="btn btn-outline-primary" (click)="decline()">{{ 'countrySelectDialog.confirmation.buttonDecline' | translate }}</button>
	<button class="btn btn-primary" (click)="confirm()">{{ 'countrySelectDialog.confirmation.buttonConfirm' | translate }}</button>
</div>
